type RegExpPattern = Readonly<{
  description: string
  name: string
  pattern: RegExp
}>

const lowercase: RegExpPattern = {
  description: 'a lowercase letter',
  name: 'lower',
  pattern: /(\[a-z\]|a-z)/,
}
const uppercase: RegExpPattern = {
  description: 'an uppercase letter',
  name: 'upper',
  pattern: /(\[A-Z\]|A-Z)/,
}

const knownPatterns: Record<string, RegExpPattern> = {
  '\\d': {
    description: 'a digit',
    name: 'digit',
    pattern: /\\d/,
  },
  '\\W': {
    description: 'a symbol',
    name: 'special',
    pattern: /\\W/,
  },
  'a-z': lowercase,
  '[a-z]': lowercase,
  'A-Z': uppercase,
  '[A-Z]': uppercase,
}

/**
 * Match simple `RegExp` patterns (like `\d` or `[A-Z]`) to `RegExpPattern`s.
 */
export function getRegExpPattern(pattern: RegExp): RegExpPattern[] {
  const source = pattern.source
  const sourceParts = source.split('|')
  return sourceParts.reduce((memo: RegExpPattern[], part: string) => {
    if (knownPatterns[part]) memo.push(knownPatterns[part])
    return memo
  }, [])
}
